import axios from "axios";
import { attachApiTerminalLogging } from "./apiTerminalLogging";
import { apiUrl, newApiBaseUrl, buildServiceURL } from "./environment";

export const axiosAuthInstance         = axios.create({ baseURL: buildServiceURL("auth") });
export const axiosSubscriptionInstance = axios.create({ baseURL: buildServiceURL("subscriptions") });
export const axiosDietInstance         = axios.create({ baseURL: buildServiceURL("diet") });
export const axiosWorkoutInstance      = axios.create({ baseURL: buildServiceURL("workouts") });
export const axiosOtherTrackerInstance = axios.create({ baseURL: buildServiceURL("other-trackers") });
export const axiosUserProfileInstance  = axiosAuthInstance;
// ms-agents has no /welldhan suffix
export const msAgentsInstance          = axios.create({ baseURL: buildServiceURL("ms-agents").replace("/welldhan", "") });

const axiosInstance = axios.create({ baseURL: apiUrl });
const axiosNewInstance = axios.create({ baseURL: newApiBaseUrl });

[
  axiosAuthInstance,
  axiosSubscriptionInstance,
  axiosDietInstance,
  axiosWorkoutInstance,
  axiosOtherTrackerInstance,
  msAgentsInstance,
  axiosInstance,
  axiosNewInstance,
].forEach(attachApiTerminalLogging);

export { axiosInstance, axiosNewInstance };
